module.exports = __webpack_public_path__ + "assets/17ced084787ec609d8ad6b24cd86a046.mp3";